/* "Barrel" of Http Interceptors */
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { CheckAuthStatusInterceptor } from './check-auth-status/check-auth-status.interceptor';

/** Http interceptor providers in outside-in order */
export const httpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: CheckAuthStatusInterceptor, multi: true },
];
